import { getCategoryAssociation, submitServices } from 'Api/companyApi'
import { parseCategoryEdit, parseGroupEdit } from 'Parsers/categoryParser'
import { getGroupList, getCategoryList } from 'Api/categoryApi'
import intersection from 'lodash/intersection'
import flatten from 'lodash/flatten'
import uniq from 'lodash/uniq'
import cloneDeep from 'lodash/cloneDeep'
import { getPlanStatus } from 'Api/subscriptionApi'
import { CategoryState } from 'Types/_Store/CompanyAccount'

const state: CategoryState = {
  requesting: {
    associationList: false,
    selectedList: false,
    groupList: false,
    categoryList: false,
    association: false,
    serviceTypeLimit: false,
  },

  stepList: [
    { id: 1, name: 'Categoria' },
    { id: 2, name: 'Especialidade' }
  ],

  serviceTypeLimit: 1,
  currentStep: 1,

  selectedCategories: [],
  selectedServices: [],

  associationList: [],
  groupList: [],
  categoryList: [],
}

const mutations = {
  request_start(state, type) {
    state.requesting[type] = true
  },

  request_success(state, type) {
    state.requesting[type] = false
  },

  request_failure(state, type) {
    state.requesting[type] = false
  },

  set_association_list(state, associationList) {
    state.associationList = associationList
  },

  set_group_list(state, groupList) {
    state.groupList = groupList
  },

  set_category_list(state, categoryList) {
    state.categoryList = categoryList
  },

  set_current_step(state, currentStep) {
    state.currentStep = currentStep
  },

  set_selected_categories(state, selectedCategories) {
    state.selectedCategories = selectedCategories
  },

  set_selected_services(state, selectedServices) {
    state.selectedServices = selectedServices
  },

  set_service_type_limit(state, serviceTypeLimit) {
    state.serviceTypeLimit = serviceTypeLimit
  }
}

const actions = {
  async getServiceTypeLimit({ commit }) {
    commit('request_start', 'serviceTypeLimit')

    try {
      const { data } = await getPlanStatus()
      const serviceTypeLimit = data.benefit.maxNumberOfServiceType

      commit('set_service_type_limit', serviceTypeLimit)
      commit('request_success', 'serviceTypeLimit')

      return { data }
    } catch (err) {
      commit('request_failure', 'serviceTypeLimit')

      throw err
    }
  },

  async getAssociationList({ commit }){
    commit('request_start', 'associationList')

    try{
      const { data } = await getCategoryAssociation()
      const associationList = data.map(parseCategoryEdit)
      commit('set_association_list', associationList)
      commit('request_success', 'associationList')

      return { data }
    } catch(err) {
      commit('request_failure', 'associationList')

      throw err
    }
  },

  async getGroupList ({ commit }) {
    commit('request_start', 'groupList')

    try {
      const { data } = await getGroupList()
      const groupList = data.map(parseGroupEdit)

      commit('set_group_list', groupList)
      commit('request_success', 'groupList')

      return data
    } catch(err) {
      commit('request_failure', 'groupList')

      throw err
    }
  },

  async getCategoryList({ commit, state }, idList) {
    const { selectedServices = [] } = state

    commit('request_start', 'categoryList')

    try{
      const result = await getCategoryList(idList.join(','))

      const data = (result.data === '')
        ? []
        : result.data

      const categoryList = data.map(parseCategoryEdit)


      const apiServiceList = flatten(categoryList.map(category => category.serviceTypes.map(service => service.id)))
      const serviceList = intersection(selectedServices, apiServiceList)

      commit('set_category_list', categoryList)
      commit('set_selected_services', serviceList)

      commit('request_success', 'categoryList')

      return { data }
    } catch(err) {
      commit('request_failure', 'categoryList')

      throw err
    }
  },

  async getSelectedList({ commit, state }) {
    commit('request_start', 'selectedList')

    try {
      const { data } = await getCategoryAssociation()
      const associationList = data.map(parseCategoryEdit)

      let categoryList = cloneDeep(state.selectedCategories)|| []
      let serviceList = []

      associationList.forEach(category => {
        categoryList.push(category.id)

        serviceList.push(...category.serviceTypes.map(service => service.id))
      })

      categoryList = uniq(categoryList)
      commit('set_selected_categories', categoryList)

      commit('set_selected_services', serviceList)

      commit('request_success', 'selectedList')

      return data
    } catch (err) {
      commit('request_failure', 'selectedList')

      throw err
    }
  },

  async associateCategories({ commit }, serviceTypeList) {
    commit('request_start', 'association')

    try {
      const { data } = await submitServices(serviceTypeList)

      commit('request_success', 'association')

      return data
    } catch (err) {
      commit('request_failure', 'association')

      throw err
    }
  },

  addCategory({ commit, state }, category) {
    const { selectedCategories } = state
    const categoryList = selectedCategories.filter(id => id !== category)

    categoryList.push(category)

    commit('set_selected_categories', categoryList)
  },

  removeCategory({ commit, state }, category) {
    const { selectedCategories } = state
    const categoryList = selectedCategories.filter(id => id !== category)

    commit('set_selected_categories', categoryList)
  },

  addService({ commit, state }, service) {
    const { selectedServices } = state
    const serviceList = selectedServices.filter(id => id !== service)

    serviceList.push(service)

    commit('set_selected_services', serviceList)
  },

  removeService({ commit, state }, service) {
    const { selectedServices } = state
    const serviceList = selectedServices.filter(id => id !== service)

    commit('set_selected_services', serviceList)
  },

  nextStep({ commit, state }) {
    const { stepList, currentStep } = state
    const isLastStep = stepList.every(item => item.id > currentStep)

    const newStep = isLastStep
      ? currentStep
      : currentStep + 1

    commit('set_current_step', newStep)
  },

  previousStep({ commit, state }) {
    const { stepList, currentStep } = state
    const isFirstStep = stepList.every(item => item.id > currentStep)

    const newStep = isFirstStep
      ? currentStep
      : currentStep - 1

    commit('set_current_step', newStep)
  },
}

export default {
  namespaced: true,

  state,
  mutations,
  actions,
}